export default function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/call.js
// module id = 180
// module chunks = 0